/* Lausitzring Elemente — eigenständiges Verhalten, keine Abhängigkeiten */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  /* Einblenden beim Scrollen */
  function initReveal() {
    var targets = all('.lr-reveal:not([data-lr-done]), .lr-stagger:not([data-lr-done])');
    if (!targets.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
        el.setAttribute('data-lr-done', '');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      el.setAttribute('data-lr-done', '');
      io.observe(el);
    });
  }

  /* Countdown */
  var timer = null;
  function initCountdowns() {
    var nodes = all('[data-lr-countdown]');
    if (!nodes.length) return;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var now = Date.now();
      nodes.forEach(function (node) {
        var target = parseInt(node.getAttribute('data-lr-countdown'), 10) * 1000;
        if (isNaN(target)) return;
        var diff = target - now;
        if (diff <= 0) {
          var live = node.getAttribute('data-lr-live');
          if (live && node.getAttribute('data-lr-elapsed') !== 'true') {
            node.setAttribute('data-lr-elapsed', 'true');
            node.innerHTML = '<span class="lr-countdown--live">' + live + '</span>';
          }
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var set = function (key, value) {
          var el = node.querySelector('[data-lr-unit="' + key + '"]');
          if (el) el.textContent = pad(value);
        };
        set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
        var compact = node.querySelector('[data-lr-compact]');
        if (compact) {
          compact.textContent = d > 0 ? 'noch ' + d + (d === 1 ? ' Tag' : ' Tage') : 'noch ' + h + ' Std.';
        }
      });
    }
    tick();
    if (timer) clearInterval(timer);
    timer = setInterval(tick, 1000);
  }

  /* Slider: startet bei der naechsten Veranstaltung, laeuft fortlaufend im Kreis */
  function initSliders() {
    all('[data-lr-slider]:not([data-lr-ready])').forEach(function (slider) {
      slider.setAttribute('data-lr-ready', '');
      var viewport = slider.querySelector('[data-lr-viewport]');
      var slides = all('.lr-slide', slider);
      var prev = slider.querySelector('[data-lr-prev]');
      var next = slider.querySelector('[data-lr-next]');
      var dots = all('[data-lr-dot]', slider);
      var current = slider.querySelector('[data-lr-current]');
      if (!viewport || slides.length < 2) return;

      /* Fortlaufend: beide Pfeile bleiben immer bedienbar */
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;

      function index() {
        return Math.round(viewport.scrollLeft / viewport.clientWidth);
      }

      function sync() {
        var i = index();
        dots.forEach(function (dot, d) {
          dot.setAttribute('aria-current', d === i ? 'true' : 'false');
        });
        if (current) current.textContent = i + 1;
      }

      function goTo(i) {
        var target = i;
        var jump = false;
        if (target < 0) { target = slides.length - 1; jump = true; }
        if (target > slides.length - 1) { target = 0; jump = true; }
        viewport.scrollTo({
          left: target * viewport.clientWidth,
          behavior: (reduce || jump) ? 'auto' : 'smooth'
        });
        setTimeout(sync, 60);
      }

      if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
      if (next) next.addEventListener('click', function () { goTo(index() + 1); });
      dots.forEach(function (dot, d) {
        dot.addEventListener('click', function () { goTo(d); });
      });

      var scrollTimer;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(sync, 90);
      }, { passive: true });

      window.addEventListener('resize', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(sync, 150);
      });

      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
      });

      sync();
    });
  }

  function boot() {
    initReveal();
    initCountdowns();
    initSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
